import { OrganizationKeyName } from "../../../model/Organization";
import { RootState } from "../../../store";

import * as authSelectors from "../../auth/authSelectors";

export const shopList = (state: RootState, org?: OrganizationKeyName) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.shopList;
};

export const isLoadingShopList = (
  state: RootState,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.shopListIsLoading;
};

export const shop = (
  state: RootState,
  id: string | undefined,
  org?: OrganizationKeyName
) => {
  if (!id) {
    return;
  }

  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.shop?.[id];
};

export const isLoadingShop = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  if (!id) {
    return false;
  }

  return !!state.shop.org[org]?.shopIsLoading[id];
};

export const isLoadingShopTimeslotTemplates = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  if (!id) {
    return false;
  }

  return !!state.shop.org[org]?.timeslotTemplatesAreLoading[id];
};

export const isLoadingShopTimeslotTemplateUpdate = (
  state: RootState,
  id: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return !!state.shop.org[org]?.timeslotTemplateUpdateLoading[id];
};

export const upsertShopErrors = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.upsertShopErrors[id || "__new"];
};
